import { Component, Input, Output, EventEmitter } from "@angular/core";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";

@Component({
  selector: "app-no-ticker-popup",
  templateUrl: "./no-ticker-popup.component.html",
  styleUrls: ["./no-ticker-popup.component.scss"],
})
export class NoTickerPopupComponent {
  @Input() showNoTickerPopup = false;
  @Output() onNoTickerPopupChangeClick: EventEmitter<any> = new EventEmitter();

  faInfoCircle = faInfoCircle;

  handleNoTickerPopupChangeClick() {
    this.onNoTickerPopupChangeClick.emit();
  }
}
